module.exports = __webpack_public_path__ + "static/media/bulk_upload_month_sob_calender.81b0d3a2.csv";